
/* BLACK BARON — independent, no-framework storefront demo. */
'use strict';

const INLINE_IMAGES = window.BB_ASSET_URLS || {};
const assetUrl = name => INLINE_IMAGES[name] || name;
const SHOP_URL = '#collection';
const PRODUCTS = [
  {
    id:'stealth',number:'001',name:'STEALTH',sub:'Der geometrische Totenkopf',category:'ring',price:450,weight:'36 g',measurements:'Höhe 26 mm · Breite 20 mm',
    images:['stealth-front.webp','stealth-angle.webp','stealth-back.webp'],
    description:'Kantig. Radikal. Unverwechselbar. Der Stealth-Siegelring inszeniert einen facettierten Totenkopf in massivem Silber — ein Design mit Ecken, Kanten und eigener Haltung.',
  },
  {
    id:'vario',number:'002',name:'VARIO CROSS',sub:'Das Zeichen der Stärke',category:'ring',price:320,weight:'37 g',measurements:'Breite 26,5 mm · Höhe 22 mm',
    images:['vario-front.webp','vario-back.webp'],
    description:'Ein klassischer Siegelring mit kraftvoller Schwertlilie und barocken Details. Aus massivem 925 Sterling Silber gefertigt, verbindet der Vario Cross Tradition mit rebellischem Charakter.',
  },
  {
    id:'brand',number:'003',name:'BRAND SKULL',sub:'Black Baron Signature',category:'ring',price:220,weight:'14,5 g',measurements:'Höhe 9 mm',
    images:['brand-skull.webp','brand-inside.webp'],
    description:'Ein klares Statement am Finger: gravierte BLACK-BARON-Schrift und ikonische Skull-Details. Ein markanter Bandring für jeden Tag.',
  },
  {
    id:'tag',number:'004',name:'BLACK BARON TAG',sub:'Skull & Signature',category:'pendant',price:290,weight:'23,5 g',measurements:'48 × 30 × 3 mm',
    images:['baron-tag-front.webp','baron-tag-angle.webp','baron-tag-back.webp'],
    description:'Das BLACK BARON TAG vereint einen plastischen Totenkopf mit ausdrucksstarker Typografie und oxidierter Silberoptik. Ein Anhänger mit eigener Geschichte.',
  },
  {
    id:'ice',number:'005',name:'APOCALYPSE ICE',sub:'Die dunkle Eleganz',category:'pendant',price:1250,weight:'53,5 g',measurements:'89 × 47 × 11 mm',
    images:['apocalypse-ice.webp','apocalypse-cross.webp'],
    description:'Filigrane florale Details, kreuzförmige Silhouette und fein ausgearbeitete Totenkopfmotive. Ein aufwendiges Schmuckstück für ausdrucksstarke Looks.',
  },
  {
    id:'blazin',number:'006',name:'APOCALYPSE SKULL BLAZIN',sub:'Rebellion in Silber',category:'pendant',price:980,weight:'58,6 g',measurements:'89 × 47 × 13 mm',
    images:['apocalypse-blazin.webp','apocalypse-side.webp'],
    description:'Ein außergewöhnlicher Kreuzanhänger mit kunstvoller Ornamentik und Skull-Details. Handgefertigtes Silber — kompromisslos im Ausdruck.',
  }
];

// The original 6-piece catalog supplies *identical* imagery, labels and sizing.
// When assigned in the Theme Editor, Shopify supplies live price, inventory and variants.
PRODUCTS.forEach(p=>{
  const shopProduct=window.BB_SHOPIFY_PRODUCTS?.[p.id];
  if(shopProduct?.configured){p.shopify=shopProduct;p.price=shopProduct.priceCents/100;}
});
const $ = id => document.getElementById(id);
const money = amount => new Intl.NumberFormat('de-DE',{style:'currency',currency:'EUR'}).format(amount);
const productOf = id => PRODUCTS.find(p=>p.id===id);
const isRing = product => product.category==='ring';
let cart={items:[],item_count:0,total_price:0};
const bbRoot=(window.BB_SHOPIFY_ROOT||'/').replace(/\/?$/,'/');
const bbRoute=path=>bbRoot+path.replace(/^\//,'');
async function refreshCart(){
  try {
    const response=await fetch(bbRoute('cart.js'),{credentials:'same-origin'});
    if(!response.ok)throw new Error('Warenkorb konnte nicht geladen werden');
    cart=await response.json();updateCartCount();renderCart();
  }catch(err){console.warn('BLACK BARON cart:',err);}
}

let selectedProduct = null;
let detailQuantity = 1;
let activeImageIndex = 0;
let toastTimeout = 0;

function persistCart(){return refreshCart();}
function updateCartCount(){
  const counter=$('cartCount');if(counter)counter.textContent=String(cart.item_count||0);
}

function lockPage(){document.body.classList.add('is-locked');}
function unlockPage(){
  if(!$('cartDrawer').classList.contains('is-open') && !$('productModal').classList.contains('is-open') && !$('checkoutModal').classList.contains('is-open')) document.body.classList.remove('is-locked');
}
function notify(message){
  const toast=$('toast');toast.textContent=message;toast.classList.add('is-visible');
  clearTimeout(toastTimeout);toastTimeout=setTimeout(()=>toast.classList.remove('is-visible'),2800);
}

function renderProducts(filter='all'){
  const grid=$('productGrid');
  const visible=PRODUCTS.filter(p=>filter==='all'||p.category===filter);
  grid.innerHTML=visible.map((p,i)=>`
    <article class="product-card" style="--delay:${(i%5)*-.85}s">
      <div class="product-card-header"><span class="product-number">BB—${p.number}</span><span class="product-type">${p.category==='ring'?'SILVER RING':'PENDANT'} / 925</span></div>
      <button class="product-image-button" data-product="${p.id}" aria-label="${p.name} im Detail ansehen"><img loading="lazy" src="${assetUrl(p.images[0])}" alt="BLACK BARON ${p.name} Schmuckstück"></button>
      <div class="product-card-footer"><div class="product-card-name"><strong>${p.name}</strong><span>${p.sub}</span></div><div class="product-card-actions"><strong class="product-price">${money(p.price)}</strong><button type="button" class="card-arrow" data-product="${p.id}" aria-label="${p.name} ansehen">✕</button></div></div>
    </article>`).join('');
}
function setFilter(filter){
  document.querySelectorAll('.filter-btn').forEach(btn=>{const active=btn.dataset.filter===filter;btn.classList.toggle('active',active);btn.setAttribute('aria-pressed',String(active));});
  renderProducts(filter);
}

function modalImageAt(index){
  if(!selectedProduct)return;
  activeImageIndex=(index+selectedProduct.images.length)%selectedProduct.images.length;
  $('modalImage').src=assetUrl(selectedProduct.images[activeImageIndex]);
  $('modalImage').alt=`${selectedProduct.name} — Ansicht ${activeImageIndex+1} von ${selectedProduct.images.length}`;
  document.querySelectorAll('.modal-thumb').forEach((b,i)=>b.classList.toggle('active',i===activeImageIndex));
}
function openProduct(id){
  const p=productOf(id);if(!p)return;
  if($('cartDrawer').classList.contains('is-open'))closeCart(false);
  selectedProduct=p;detailQuantity=1;activeImageIndex=0;
  $('modalSerial').textContent='BLACK BARON / '+p.number;
  $('modalCategory').textContent=(isRing(p)?'RING':'ANHÄNGER')+' / BLACK BARON';
  $('modalTitle').textContent=p.name;
  $('modalPrice').textContent=money(p.price);
  $('modalDescription').textContent=p.description;
  $('modalWeight').textContent=p.weight || 'Keine Angabe';
  $('modalMeasurements').textContent=p.measurements || 'Keine Angabe';
  $('modalError').textContent='';
  $('qtyValue').textContent='1';
  $('sizeContainer').hidden=!isRing(p);
  $('productSize').value='';
  const variants=p.shopify?.variants||[];
  if(p.shopify?.configured){
    const available=variants.filter(v=>v.available);
    if(available.length>1){
      $('sizeContainer').hidden=false;
      $('sizeContainer').querySelector('label').textContent=isRing(p)?'RINGGRÖSSE':'VARIANTE';
      $('productSize').innerHTML='<option value="">VARIANTE WÄHLEN</option>'+available.map(v=>`<option value="${v.id}">${v.title}</option>`).join('');
    }else{
      $('sizeContainer').hidden=true;
    }
    if(!available.length){$('modalError').textContent='Aktuell nicht verfügbar.';}
  }else{
    $('sizeContainer').hidden=true;
    $('modalError').textContent='Produktvorschau – für Kauf im Theme-Editor ein Shopify-Produkt zuordnen.';
  }
  $('originalProductLink').dataset.productId=p.id;
  $('modalThumbs').innerHTML=p.images.map((img,i)=>`<button class="modal-thumb ${i===0?'active':''}" data-img="${i}" type="button" aria-label="Produktansicht ${i+1}"><img src="${assetUrl(img)}" alt=""></button>`).join('');
  modalImageAt(0);
  $('productOverlay').hidden=false;
  $('productModal').setAttribute('aria-hidden','false');
  $('productModal').classList.add('is-open');
  lockPage();
  $('closeProduct').focus({preventScroll:true});
}
function closeProduct(shouldUnlock=true){
  $('productModal').classList.remove('is-open');
  $('productModal').setAttribute('aria-hidden','true');
  $('productOverlay').hidden=true;
  if(shouldUnlock)unlockPage();
}
async function addSelectedProduct(){
  if(!selectedProduct)return;
  const p=selectedProduct;
  if(!p.shopify?.configured){$('modalError').textContent='Bitte dieses Produkt zuerst im Shopify-Theme-Editor zuordnen.';return;}
  const options=p.shopify.variants.filter(v=>v.available);
  const choice=$('productSize').value;
  let variant;
  if(options.length===1)variant=options[0];
  else if(choice){variant=options.find(v=>String(v.id)===choice);}
  if(!variant){$('modalError').textContent='Bitte wähle eine verfügbare Variante.';$('productSize').focus();return;}
  $('modalError').textContent='';
  const btn=$('addToCart');btn.disabled=true;
  try{
    const response=await fetch(bbRoute('cart/add.js'),{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:variant.id,quantity:detailQuantity}]})});
    const result=await response.json();
    if(!response.ok)throw new Error(result.description||result.message||'Artikel konnte nicht hinzugefügt werden.');
    await refreshCart();closeProduct(false);openCart();notify(p.name+' wurde hinzugefügt.');
  }catch(err){$('modalError').textContent=err.message||'Bitte erneut versuchen.';}
  finally{btn.disabled=false;}
}
function renderCart(){
  const target=$('cartItems');if(!target)return;
  const total=(cart.total_price||0)/100;
  $('cartTotal').textContent=money(total);
  const lines=cart.items||[];
  $('checkoutButton').disabled=!lines.length;
  $('checkoutButton').style.opacity=lines.length?'1':'.5';
  if(!lines.length){target.innerHTML='<div class="cart-empty"><div class="empty-symbol">✦</div><h3>NOCH PLATZ FÜR REBELLION.</h3><p>Hier ist noch nichts drin. Entdecke deine neuen Lieblingsstücke.</p></div>';return;}
  const esc=s=>String(s??'').replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  target.innerHTML=lines.map((line,index)=>{
    const image=line.image?`<img src="${esc(line.image)}" alt="${esc(line.product_title)}">`:'';
    const label=line.variant_title && line.variant_title!=='Default Title'?line.variant_title:'925 STERLING SILBER';
    return `<div class="cart-line"><div class="cart-line-image">${image}</div><div class="cart-line-info"><div class="cart-line-name">${esc(line.product_title)}</div><div class="cart-line-size">${esc(label)}</div><div class="cart-line-price">${money((line.final_line_price||0)/100)}</div><div class="cart-controls"><div class="cart-quantity"><button type="button" data-change="${index}" data-delta="-1" aria-label="Menge verringern">−</button><span>${line.quantity}</span><button type="button" data-change="${index}" data-delta="1" aria-label="Menge erhöhen">+</button></div><button type="button" class="remove-cart" data-remove="${index}">ENTFERNEN</button></div></div></div>`;
  }).join('');
}
async function changeCartItem(index,delta,remove=false){
  const line=cart.items?.[index];if(!line)return;
  const quantity=remove?0:Math.max(0,Math.min(99,line.quantity+delta));
  try{
    const response=await fetch(bbRoute('cart/change.js'),{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:line.key,quantity})});
    if(!response.ok)throw new Error('Menge konnte nicht geändert werden.');
    cart=await response.json();updateCartCount();renderCart();
  }catch(err){notify(err.message||'Bitte erneut versuchen.');}
}

function openCart(){
  if($('productModal').classList.contains('is-open'))closeProduct(false);
  $('drawerOverlay').hidden=false;
  $('cartDrawer').setAttribute('aria-hidden','false');
  renderCart();refreshCart();
  $('cartDrawer').classList.add('is-open');
  lockPage();$('closeCart').focus({preventScroll:true});
}
function closeCart(shouldUnlock=true){
  $('cartDrawer').classList.remove('is-open');
  $('cartDrawer').setAttribute('aria-hidden','true');
  $('drawerOverlay').hidden=true;
  if(shouldUnlock)unlockPage();
}
function showCheckout(){
  if(!cart.item_count)return;
  window.location.href=bbRoute('checkout');
}
function closeCheckout(shouldUnlock=true){
  $('checkoutModal').classList.remove('is-open');
  $('checkoutModal').setAttribute('aria-hidden','true');
  if(shouldUnlock)unlockPage();
}

function initLogo(){
  const stage=$('logoStage'),rotator=$('logoRotator'),canvas=$('logoCanvas');
  const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
  const renderer=window.createBlackBaronLogo3D?.(canvas,window.BB_LOGO_TEXTURE || window.BB_LOGO_TEXTURE_URL);
  const rotation={x:-10,y:-19,dragging:false,px:0,py:0,automatic:!reduced.matches};
  let last=0,visible=true;
  // Do not hide the complete original image while Shopify is still loading
  // the front/back chrome texture. Without it, only 3D walls are visible.
  // The CSS extruded logo stays visible until the WebGL face is ready.
  const draw=(time)=>{
    const dt=last?Math.min((time-last)*.001,.055):0;last=time;
    if(visible){
      if(rotation.automatic&&!rotation.dragging&&!reduced.matches)rotation.y+=dt*18;
      const yaw=rotation.y, pitch=rotation.x+(rotation.automatic&&!rotation.dragging?Math.sin(time*.00055)*3:0);
      if(renderer && renderer.ready()){
        renderer.render(pitch,yaw);
        if(!rotator.classList.contains('is-webgl')) rotator.classList.add('is-webgl');
        rotator.style.transform='none';
      } else {
        // This also covers browsers that cannot load a WebGL texture.
        if(rotator.classList.contains('is-webgl')) rotator.classList.remove('is-webgl');
        rotator.style.transform=`rotateX(${pitch}deg) rotateY(${yaw}deg)`;
      }
    }
    requestAnimationFrame(draw);
  };
  if('IntersectionObserver' in window){
    new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;last=0;},{threshold:0}).observe(stage);
  }
  requestAnimationFrame(draw);
  stage.addEventListener('pointerdown',e=>{
    if(e.button!==0 && e.pointerType==='mouse')return;
    rotation.dragging=true;rotation.px=e.clientX;rotation.py=e.clientY;
    stage.setPointerCapture(e.pointerId);
  });
  stage.addEventListener('pointermove',e=>{
    if(!rotation.dragging)return;
    const dx=e.clientX-rotation.px,dy=e.clientY-rotation.py;
    rotation.y+=dx*.49;rotation.x=Math.max(-64,Math.min(64,rotation.x-dy*.27));
    rotation.px=e.clientX;rotation.py=e.clientY;
  });
  const end=()=>rotation.dragging=false;
  stage.addEventListener('pointerup',end);stage.addEventListener('pointercancel',end);
  stage.addEventListener('lostpointercapture',end);
  const pause=$('toggleRotation');
  pause.addEventListener('click',()=>{
    if(reduced.matches){rotation.automatic=false;return;}
    rotation.automatic=!rotation.automatic;
    pause.textContent=rotation.automatic?'PAUSE':'PLAY';
    pause.setAttribute('aria-pressed',String(!rotation.automatic));
  });
  if(reduced.matches){pause.textContent='PLAY';pause.setAttribute('aria-pressed','true');}
  $('resetLogo').addEventListener('click',()=>{rotation.x=-10;rotation.y=-19;});
}

// ONE flight camera across the blue sky, descending horizon, and bright cloud deck.
// The hero does not cut to a second background: both photos blend inside this sticky viewport.
function initFlightCamera(){
  const scene=$('flightSequence'),sky=$('flightSky'),white=$('flightWhiteClouds'),vignette=$('flightVignette');
  if(!scene)return;
  const hero=scene.querySelector('.hero');
  const faded=hero.querySelectorAll('.hero-logo-stage,.hero-jewel,.hero-bottom,.hero-overline,.logo-hint,.scroll-cue,.hero-rails');
  const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
  const clamp=n=>Math.min(1,Math.max(0,n));
  const sm=(a,b,t)=>{const k=clamp((t-a)/(b-a));return k*k*(3-2*k)};
  const num=x=>x.toFixed(3);
  let frame=0;
  function render(){
    frame=0;
    if(reduced.matches){
      faded.forEach(el=>el.style.opacity='');
      sky.style.transform='';white.style.opacity='0';return;
    }
    const rect=scene.getBoundingClientRect(),y=Math.max(0,-rect.top);
    const total=Math.max(1,scene.offsetHeight-window.innerHeight);
    const p=clamp(y/total),h=clamp(y/Math.max(1,hero.offsetHeight));
    // The shared sky also keeps moving through the unpin/exit phase, rather
    // than freezing while the final cloud viewport slides upward and away.
    const departure=sm(0,1,clamp((y-total)/Math.max(1,window.innerHeight)));
    const lower=sm(.05,.60,p);
    sky.style.transform=`translate3d(0,${num(-4-26*lower-10*departure)}vh,0) scale(${num(1.05+1.52*sm(.02,.68,p)+.32*departure)})`;
    sky.style.opacity=num(1-sm(.43,.70,p)*.55);
    white.style.transform=`translate3d(0,${num(10-42*sm(.28,.94,p)-24*departure)}vh,0) scale(${num(1.02+2.55*sm(.27,.94,p)+.62*departure)})`;
    white.style.opacity=num(sm(.28,.64,p)*(1-.12*sm(.88,1,p)));
    vignette.style.opacity=num(.92*(1-sm(.31,.65,p)));
    const fade=1-sm(.18,.78,h);
    faded.forEach(el=>{el.style.opacity=num(fade);});
  }
  const tick=()=>{if(!frame)frame=requestAnimationFrame(render)};
  window.addEventListener('scroll',tick,{passive:true});
  window.addEventListener('resize',tick,{passive:true});
  reduced.addEventListener?.('change',tick);
  render();
}

// Scroll-linked fly-through. Moves progressively nearer cloud layers at different
// speeds so the white cloud photo feels volumetric instead of flat.
function initCloudDive(){
  const section=$('cloudDive');
  if(!section)return;
  const layers={
    sky:$('cloudDiveSky'),far:$('cloudDiveFar'),left:$('cloudDiveLeft'),
    right:$('cloudDiveRight'),near:$('cloudDiveNear'),
    entry:$('cloudDiveEntry'),whiteout:$('cloudDiveWhiteout'),
    exit:$('cloudDiveExit'),copy:$('cloudDiveCopy')
  };
  const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
  const clamp=(n,a=0,b=1)=>Math.max(a,Math.min(b,n));
  const smooth=(a,b,t)=>{const u=clamp((t-a)/(b-a));return u*u*(3-2*u)};
  const number=n=>n.toFixed(3);
  function render(){
    if(reduced.matches)return;
    const rect=section.getBoundingClientRect();
    // Continue the cloud flight for the *entire* visible chapter. The sticky
    // viewport unpins during the final viewport-height of the section; tracking
    // the whole section instead of just its pinned scroll distance avoids a
    // frozen cloud frame before it has left the screen.
    const fullTravel=Math.max(1,section.getBoundingClientRect().height);
    const p=clamp(-rect.top/fullTravel);
    const accelerated=p*p*(3-2*p);
    const tail=smooth(.72,.995,p);
    const exit=smooth(.90,.999,p);
    layers.sky.style.transform=`translate3d(0,${number(-p*21-tail*6)}%,0) scale(${number(1.04+1.9*accelerated+.42*tail)})`;
    layers.far.style.transform=`translate3d(${number(-p*8-tail*2)}vw,${number(-p*34-tail*10)}vh,0) scale(${number(1.04+p*1.62+.18*tail)})`;
    layers.left.style.transform=`translate3d(${number(-p*44-tail*6)}vw,${number(-p*37-tail*14)}vh,0) scale(${number(1+p*3.05+.22*tail)})`;
    layers.right.style.transform=`translate3d(${number(p*48+tail*7)}vw,${number(-p*42-tail*15)}vh,0) scale(${number(1+p*3.12+.24*tail)})`;
    layers.near.style.transform=`translate3d(${number(p*5+tail*3)}vw,${number(-p*83-tail*18)}vh,0) scale(${number(1+p*4.05+.32*tail)})`;
    layers.far.style.opacity=number(smooth(.08,.30,p)*.48*(1-smooth(.86,.985,p)));
    layers.left.style.opacity=number(smooth(.10,.38,p)*.74*(1-smooth(.86,.985,p)));
    layers.right.style.opacity=number(smooth(.15,.43,p)*.85*(1-smooth(.84,.982,p)));
    layers.near.style.opacity=number(smooth(.24,.54,p)*.92*(1-smooth(.88,.992,p)));
    layers.entry.style.opacity=number(.72*(1-smooth(.0,.42,p)));
    layers.whiteout.style.opacity=number(smooth(.74,.92,p)*.80*(1-.55*smooth(.94,1,p)));
    layers.exit.style.opacity=number(exit);
    layers.copy.style.opacity=number(window.BB_SILENCE_CLOUD_COPY?0:smooth(.04,.18,p)*(1-smooth(.70,.86,p)));
    layers.copy.style.transform=`translate(-50%,-50%) translateY(${number(-p*56)}px)`;
  }
  let rafId=0;
  const schedule=()=>{
    if(rafId)return;
    rafId=window.requestAnimationFrame(()=>{rafId=0;render()});
  };
  window.addEventListener('scroll',schedule,{passive:true});
  window.addEventListener('resize',schedule,{passive:true});
  reduced.addEventListener?.('change',schedule);
  render();
}

function init(){
  $('year').textContent=String(new Date().getFullYear());
  renderProducts();updateCartCount();renderCart();refreshCart();initLogo();initFlightCamera();initCloudDive();
  document.querySelectorAll('.filter-btn').forEach(b=>b.addEventListener('click',()=>setFilter(b.dataset.filter)));
  document.addEventListener('click',event=>{
    const element=event.target.closest('[data-product]');
    if(element){openProduct(element.dataset.product);return;}
  });
  $('productGrid').addEventListener('keydown',e=>{ if((e.key==='Enter'||e.key===' ') && e.target.matches('.product-card')){e.preventDefault();openProduct(e.target.dataset.product)} });
  $('modalThumbs').addEventListener('click',e=>{const b=e.target.closest('[data-img]');if(b)modalImageAt(Number(b.dataset.img));});
  $('closeProduct').addEventListener('click',()=>closeProduct());
  $('productOverlay').addEventListener('click',()=>closeProduct());
  $('qtyMinus').addEventListener('click',()=>{$('qtyValue').textContent=String(detailQuantity=Math.max(1,detailQuantity-1));});
  $('qtyPlus').addEventListener('click',()=>{$('qtyValue').textContent=String(detailQuantity=Math.min(99,detailQuantity+1));});
  $('addToCart').addEventListener('click',addSelectedProduct);
  $('productSize').addEventListener('change',()=>{$('modalError').textContent='';});
  $('openCart').addEventListener('click',openCart);
  $('closeCart').addEventListener('click',()=>closeCart());
  $('continueShopping').addEventListener('click',()=>closeCart());
  $('drawerOverlay').addEventListener('click',()=>{
    if($('checkoutModal').classList.contains('is-open'))closeCheckout(); else closeCart();
  });
  $('cartItems').addEventListener('click',e=>{
    const change=e.target.closest('[data-change]');const remove=e.target.closest('[data-remove]');
    if(change)changeCartItem(Number(change.dataset.change),Number(change.dataset.delta));
    if(remove)changeCartItem(Number(remove.dataset.remove),0,true);
  });
  $('checkoutButton').addEventListener('click',showCheckout);
  $('closeCheckout').addEventListener('click',closeCheckout);
  $('backToCart').addEventListener('click',()=>{closeCheckout();openCart();});
  document.addEventListener('keydown',e=>{
    if(e.key!=='Escape')return;
    if($('checkoutModal').classList.contains('is-open'))closeCheckout();
    else if($('productModal').classList.contains('is-open'))closeProduct();
    else if($('cartDrawer').classList.contains('is-open'))closeCart();
  });
  const header=$('siteHeader');
  const onScroll=()=>header.classList.toggle('scrolled',window.scrollY>25);
  window.addEventListener('scroll',onScroll,{passive:true});onScroll();
  const menu=$('mobileNavToggle');
  menu.addEventListener('click',()=>{
    const open=!$('mobileNav').classList.contains('open');
    $('mobileNav').classList.toggle('open',open);menu.classList.toggle('is-open',open);menu.setAttribute('aria-expanded',String(open));
    menu.setAttribute('aria-label',open?'Menü schließen':'Menü öffnen');
  });
  document.querySelectorAll('.mobile-nav a').forEach(link=>link.addEventListener('click',()=>{
    $('mobileNav').classList.remove('open');menu.classList.remove('is-open');menu.setAttribute('aria-expanded','false');
  }));
  if('IntersectionObserver' in window){
    const observer=new IntersectionObserver(entries=>entries.forEach(e=>{if(e.isIntersecting){e.target.classList.add('in-view');observer.unobserve(e.target);}}),{threshold:.12});
    document.querySelectorAll('.reveal').forEach(e=>observer.observe(e));
  }else document.querySelectorAll('.reveal').forEach(e=>e.classList.add('in-view'));
}

document.addEventListener('DOMContentLoaded',init);

